const BASE_URL = process.env.REACT_APP_BASE_URL;
export async function fetchSchemes(departmentId, schemeType) {
  try {
    schemeType=schemeType?.split("_")[1] || null
    let filterParts = [];

    if (departmentId) {
      filterParts.push(`department eq '${departmentId}'`);
    }

    if (schemeType) {
      filterParts.push(`schemeType eq '${schemeType}'`);
    }

    let url = `/o/c/schemeconfigurators?pageSize=-1&sort=schemeName:asc&restrictFields=actions`;

    if (filterParts.length > 0) {
      url += `&filter=${filterParts.join(" and ")}`;
    }

    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "x-csrf-token": window.Liferay?.authToken || ""
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch schemes: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data?.items) ? data.items : [];

  } catch (error) {
    console.error("Error fetching schemes:", error);
    return [];
  }
}

export async function fetchDepartments(typeofscheme) {
  try {

    let url = `/o/c/departments?pageSize=-1&sort=name:asc&restrictFields=actions`;

    if (typeofscheme) {
      url += `&filter=contains(typeofscheme,'${typeofscheme}')`;
    }

    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "x-csrf-token": window.Liferay?.authToken || ""
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch departments: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data?.items) ? data.items : [];

  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
}

export async function fetchTypeOfSchemes() {
  try {

    const response = await fetch(
      `/o/c/typeofschemes?pageSize=-1&sort=schemeType:asc&restrictFields=actions`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "x-csrf-token": window.Liferay?.authToken || ""
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch type of schemes: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data?.items) ? data.items : [];

  } catch (error) {
    console.error("Error fetching type of schemes:", error);
    return [];
  }
}

export async function fetchObjectURLByObjectId(selectElement) {
  try {

    const objectDefinitionId = selectElement?.split("_")[1] || null;

    if (!objectDefinitionId) {
      throw new Error("objectDefinitionId is required");
    }

    const response = await fetch(
      `/o/object-admin/v1.0/object-definitions/${objectDefinitionId}`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          // "x-csrf-token": window.Liferay?.authToken || ""
          "Authorization": "Basic " + btoa("prabhudasu:root")
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      let err = {};

      try {
        err = await response.json();
      } catch (e) {}

      console.error("Error fetching Object Definition:", err);

      throw new Error(
        err.title || "Failed to fetch object definition"
      );
    }

    return await response.json();

  } catch (error) {
    console.error("fetchObjectInfo Error:", error);
    throw error;
  }
}

export async function fetchObjectInfo(objectId) {
  try {

    
    if (!objectId) {
      throw new Error("objectId is required");
    }

    const response = await fetch(
      `/o/object-admin/v1.0/object-definitions/${objectId}`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          // "x-csrf-token": window.Liferay?.authToken || ""
          "Authorization": "Basic " + btoa("prabhudasu:root")
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      let err = {};

      try {
        err = await response.json();
      } catch (e) {}

      console.error("Error fetching Object Definition:", err);

      throw new Error(
        err.title || "Failed to fetch object definition"
      );
    }

    return await response.json();

  } catch (error) {
    console.error("fetchObjectInfo Error:", error);
    throw error;
  }
}

export async function fetchApplicationNumber(
  objectUrl,
  searchApplicationNumber
) {
  try {

    if (!objectUrl) {
      throw new Error("objectUrl is required");
    }

    if (!searchApplicationNumber) {
      return [];
    }

    const response = await fetch(
      `${objectUrl}?filter=applicationreferencenumber eq '${encodeURIComponent(searchApplicationNumber)}'`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": "Basic " + btoa("prabhudasu:root")
        },
        credentials: "include"
      }
    );

    if (!response.ok) {

      let err = {};

      try {
        err = await response.json();
      } catch (e) {}

      console.error("Error fetching application:", err);

      throw new Error(
        err.title || "Failed to fetch application"
      );
    }

    const data = await response.json();

    return data.items || [];

  } catch (error) {
    console.error("fetchApplicationNumber Error:", error);
    throw error;
  }
}


// export async function fetchApplicationStatus(
//   application,
//   applicationAllotmentDetailsID
// ) {
//   try {

//     const entryId = application?.id;

//     const applicationReferenceNumber =
//       application?.applicationreferencenumber;

  
//     console.log("applicationAllotmentId:::::",applicationAllotmentDetailsID)
//     const response = await fetch(
//       `/o/mhdbt-headless-service/v1.0/track-application`,
//       {
//         method: "POST",
//         headers: {
//           "Accept": "application/json",
//           "Content-Type": "application/json",
//           // "x-csrf-token":
//           //   window.Liferay?.authToken || ""
//           "Authorization": "Basic " + btoa("prabhudasu:root")
//         },
//         credentials: "include",

//         body: JSON.stringify({
//           applicationAllotmentId: Number(applicationAllotmentDetailsID),
//           applicationReferenceNumber:
//             applicationReferenceNumber,
//           entryId: Number(entryId)
//         })
//       }
//     );

//     if (!response.ok) {
//       throw new Error(
//         `Failed to fetch application status: ${response.status}`
//       );
//     }

//     return await response.json();

//   } catch (error) {

//     console.error(
//       "Error fetching application status:",
//       error
//     );

//     return null;
//   }
// }

export async function getApplicationAllotmentDetailsID(id) {

  try {

    if (!id) {
      console.error("ID is required");
      return null;
    }

    // console.log(
    //   "getApplicationAllotmentDetailsID ::::::",
    //   id
    // );

    const response = await fetch(
      `/o/c/schemeconfigurators?filter=id eq '${id}'&restrictFields=actions`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "x-csrf-token":
            window.Liferay?.authToken || ""
        },
        credentials: "include"
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch application status: ${response.status}`
      );
    }

    const data = await response.json();

    const item = data?.items?.[0];

    return item || null;

  } catch (error) {

    console.error(
      "Error fetching application status:",
      error
    );

    return null;
  }
}


// export async function fetchNumberOfDesk(workflowDefinitionId) {

//   try {

//     if (!workflowDefinitionId) {
//       console.error("workflowDefinitionId is required");
//       return null;
//     }

//     console.log(
//       "workflowDefinitionId ::::::",
//       workflowDefinitionId
//     );

//     const response = await fetch(
//       `/o/headless-admin-workflow/v1.0/workflow-definitions/${workflowDefinitionId}`,
//       {
//         method: "GET",
//         headers: {
//           "Accept": "application/json",
//           "Content-Type": "application/json",
//           "Authorization": "Basic " + btoa("prabhudasu:root")
//           // "x-csrf-token":
//           //   window.Liferay?.authToken || ""
//         },
//         credentials: "include"
//       }
//     );

//     if (!response.ok) {
//       throw new Error(
//         `Failed to fetch workflow definition: ${response.status}`
//       );
//     }

//     const data = await response.json();

//     console.log("Workflow Definition ::::::", data);

//     // Count only TASK nodes
//     const taskNodes = data?.nodes?.filter(
//       (node) => node.type === "TASK"
//     ) || [];

//     // Optional: exclude Update task if needed
//     const approvalLevels = taskNodes.filter(
//       (node) => node.name !== "Update"
//     );

//     return {
//       totalDesk: approvalLevels.length,
//       tasks: approvalLevels
//     };

//   } catch (error) {

//     console.error(
//       "Error fetching workflow definition:",
//       error
//     );

//     return null;
//   }
// }

export async function fetchNumberOfDesk(workflowDefinitionId) {
  try {
    if (!workflowDefinitionId) {
      console.error("workflowDefinitionId is required");
      return null;
    }

    // console.log(
    //   "workflowDefinitionId ::::::",
    //   workflowDefinitionId
    // );

    const response = await fetch(
      `/o/headless-admin-workflow/v1.0/workflow-definitions/${workflowDefinitionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa("prabhudasu:root"),
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch workflow definition: ${response.status}`
      );
    }

    const data = await response.json();

    // console.log("Workflow Definition ::::::", data);

    // Get only TASK nodes having Level X label
    const approvalLevels = (data?.nodes || [])
      .filter(
        (node) =>
          node.type === "TASK" &&
          /^Level\s+\d+$/i.test(node.label?.trim())
      )
      .map((node) => ({
        deskNo: Number(node.label.match(/\d+/)?.[0]),
        deskName: node.name,
        label: node.label.trim(),
      }))
      .sort((a, b) => a.deskNo - b.deskNo);
    //  console.log("approvalLevels:::::::::::::",approvalLevels)
    return {
      totalDesk: approvalLevels.length,
      tasks: approvalLevels,
    };
  } catch (error) {
    console.error(
      "Error fetching workflow definition:",
      error
    );

    return null;
  }
}

export async function fetchScrutinyLog(application) {
  try {
    console.log("application>>>>>>>>>>", application);

    const applicationreferencenumber =
      application?.applicationreferencenumber;

    const isMigrated = application?.isMigrated;

    if (!applicationreferencenumber) {
      console.log("Application Reference Number not found");
      return [];
    }

    let migratedLogs = [];

    // 1. Migrated API
    if (isMigrated) {
      try {
        const migratedResponse = await fetch(
          `${BASE_URL}/api/scrutiny/log/track/applicationNo/${applicationreferencenumber}`,
          {
            method: "GET",
            headers: {
              "Accept": "application/json",
            }
          }
        );

        if (!migratedResponse.ok) {
          console.error(
            `Migrated scrutiny API error: ${migratedResponse.status}`
          );
        } else {
          const migratedData = await migratedResponse.json();

          migratedLogs = Array.isArray(migratedData)
            ? migratedData
            : [];
        }
      } catch (error) {
        // Migrated API failed, but DO NOT stop execution
        console.error(
          "Migrated scrutiny API failed:",
          error
        );

        migratedLogs = [];
      }
    }

    // 2. Existing API will ALWAYS execute
    const response = await fetch(
      `/o/c/scrutinysendbackreferences?filter=applicationReferenceNumber eq '${applicationreferencenumber}'&restrictFields=actions`,
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "x-csrf-token": window.Liferay?.authToken || "",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;

      try {
        const errorData = await response.text();
        errorMessage += ` - ${errorData}`;
      } catch (e) {
        // Ignore
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();

    const existingLogs = Array.isArray(data?.items)
      ? data.items
      : [];

    // 3. Merge both responses
    return [
      ...migratedLogs,
      ...existingLogs
    ];

  } catch (error) {
    console.error(
      "Error in fetchScrutinyLog:",
      error
    );

    return [];
  }
}

// export async function fetchScrutinyLog(application) {
//   try {
//     let applicationreferencenumber=application?.applicationreferencenumber;
//     let isMigrated=application?.isMigrated;
//     if (!applicationreferencenumber) {
//       console.log("Application Reference Number not found");
//       return [];
//     }
  
//     if(isMigrated){

//     }

//     const response = await fetch(`/o/c/scrutinysendbackreferences?filter=applicationReferenceNumber eq '${applicationreferencenumber}'&restrictFields=actions`, {
//       method: "GET",
//       headers: {
//         "Accept": "application/json",
//         "x-csrf-token": window.Liferay?.authToken || "",
//       },
//       credentials: "include" 
//     });

//     if (!response.ok) {
//       let errorMessage = `HTTP error! status: ${response.status}`;
//       try {
//         const errorData = await response.text();
//         errorMessage += ` - ${errorData}`;
//       } catch (e) {
//         // Ignore if we can't parse error response
//       }
//       throw new Error(errorMessage);
//     }

//     const data = await response.json();
//     // console.log("Response data:", data);
    
//     // Return items if they exist
//     return data.items || data || [];

//   } catch (error) {
//     console.error("Error in checkEntryPresentInSendBackReferenceObject:", error);
//     return [];
//   }
// }

export async function fetchAllotmentStatus(objectId, applicationNo) {
    try {
        if (!objectId || !applicationNo) {
            console.log("objectId or applicationNo not found");
            return [];
        }

        const allotmentRes = await fetchObjectInfo(objectId);

        if (!allotmentRes?.restContextPath) {
            console.error("restContextPath not found");
            return [];
        }

        const filter = encodeURIComponent(
            `applicationNo eq '${applicationNo}'`
        );

        const url = `${allotmentRes.restContextPath}?filter=${filter}&restrictFields=actions`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Basic " + btoa("prabhudasu:root"),
            },
            credentials: "include",
        });

        if (!response.ok) {
            const errorText = await response.text().catch(() => "");
            throw new Error(
                `HTTP Error: ${response.status} ${response.statusText} ${errorText}`
            );
        }

        const data = await response.json();

        // console.log("Allotment Response:", data);

        const allotmentItem = data?.items?.[0];

        if (!allotmentItem?.batchID) {
            console.log("batchID not found");
            return [];
        }

        const billFilter = encodeURIComponent(
            `billNumber eq '${allotmentItem.batchID}'`
        );

        const billResponse = await fetch(
            `/o/c/billmanagements?filter=${billFilter}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: "Basic " + btoa("prabhudasu:root"),
                },
                credentials: "include",
            }
        );

        if (!billResponse.ok) {
            throw new Error(
                `Bill API Error: ${billResponse.status} ${billResponse.statusText}`
            );
        }

        const billData = await billResponse.json();

        // console.log("Bill Response:", billData);

        return billData?.items || [];
    } catch (error) {
        console.error("Error in fetchAllotmentStatus:", error);
        return [];
    }
}


// export async function fetchAllotmentStatus(objectId, applicationNo) {
//     try {
//         if (!objectId || !applicationNo) {
//             console.log("objectId or applicationNo not found");
//             return [];
//         }

//         const allotmentRes = await fetchObjectInfo(objectId);

//         console.log(
//             "allotmentRes:",
//             allotmentRes,
//             "applicationNo:",
//             applicationNo
//         );

//         if (!allotmentRes?.restContextPath) {
//             console.error("restContextPath not found");
//             return [];
//         }

//         const filter = encodeURIComponent(
//             `applicationNo eq '${applicationNo}'`
//         );

//         const url = `${allotmentRes.restContextPath}?filter=${filter}&restrictFields=actions`;

//         const response = await fetch(url, {
//             method: "GET",
//             headers: {
//                 "Accept": "application/json",
//                 "Authorization": "Basic " + btoa("prabhudasu:root")
//             },
//             credentials: "include"
//         });

//         if (!response.ok) {
//             const errorText = await response.text().catch(() => "");
//             throw new Error(
//                 `HTTP Error: ${response.status} ${response.statusText} ${errorText}`
//             );
//         }

//         const data = await response.json();
//          const billmanagementsResponse = await fetch(`/o/c/billmanagements?filter=billNumber eq '${data?.batchID}'`, {
//             method: "GET",
//             headers: {
//                 "Accept": "application/json",
//                 "Authorization": "Basic " + btoa("prabhudasu:root")
//             },
//             credentials: "include"
//         });

//         console.log("Response data:", data);

//         return billmanagementsResponse?.items || [];

//     } catch (error) {
//         console.error("Error in fetchAllotmentStatus:", error);
//         return [];
//     }
// }